const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Ufficio Corporativo",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Clinica Veterinaria",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Obbligatorio",
    },
  },
  salutation: {
    label: "Titolo",
    placeholder: "Seleziona titolo",
    errors: {
      required: "Il titolo è obbligatorio",
      invalid: "Seleziona un titolo valido",
    },
  },
  firstName: {
    label: "Nome",
    placeholder: "Mario",
    errors: {
      required: "Il nome è obbligatorio",
      minLength: "Il nome deve contenere almeno 2 caratteri",
      maxLength: "Il nome può contenere massimo 50 caratteri",
    },
  },
  lastName: {
    label: "Cognome",
    placeholder: "Rossi",
    errors: {
      required: "Il cognome è obbligatorio",
      minLength: "Il cognome deve contenere almeno 2 caratteri",
      maxLength: "Il cognome può contenere massimo 50 caratteri",
    },
  },
  email: {
    label: "Email",
    placeholder: "mario.rossi@esempio.it",
    description:
      "Inserisci un indirizzo email personale, non un indirizzo email condiviso.",
    prefixWarningTitle: "Casella di posta condivisa rilevata",
    prefixWarningDescription:
      "Consigliamo di utilizzare un indirizzo email personale per un'esperienza migliore e più personalizzata",
    errors: {
      required: "L'email è obbligatoria",
      invalidEmail: "Inserisci un indirizzo email valido",
      emailAssociatedWithYourAccount:
        "Il tuo indirizzo email è associato al tuo account e non può essere modificato.",
    },
  },
  confirmEmail: {
    label: "Conferma email",
    placeholder: "mario.rossi@esempio.it",
    errors: {
      required: "La conferma email è obbligatoria",
      invalidEmail: "Inserisci un indirizzo email valido",
      emailMatchError: "Gli indirizzi email non corrispondono",
    },
  },
  password: {
    label: "Password",
    placeholder: "Inserisci la tua password",
    errors: {
      required: "La password è obbligatoria",
    },
  },
  confirmPassword: {
    label: "Conferma password",
    placeholder: "Conferma la tua password",
    errors: {
      required: "La conferma password è obbligatoria",
      passwordMatchError: "Le password non corrispondono",
    },
  },
  addressLine1: {
    label: "Indirizzo 1",
    placeholder: "Via Roma 123",
    errors: {
      required: "L'indirizzo 1 è obbligatorio",
      minLength: "L'indirizzo 1 deve contenere almeno 5 caratteri",
      maxLength: "L'indirizzo 1 può contenere massimo 100 caratteri",
    },
  },
  addressLine2: {
    label: "Indirizzo 2",
    placeholder: "Appartamento 4B",
    errors: {
      required: "L'indirizzo 2 è obbligatorio",
      maxLength: "L'indirizzo 2 può contenere massimo 100 caratteri",
    },
  },
  city: {
    label: "Città",
    placeholder: "Roma",
    errors: {
      required: "La città è obbligatoria",
      minLength: "La città deve contenere almeno 2 caratteri",
      maxLength: "La città può contenere massimo 50 caratteri",
    },
  },
  country: {
    label: "Paese",
    placeholder: "Seleziona paese",
    errors: {
      required: "Il paese è obbligatorio",
      invalid: "Seleziona un paese valido",
    },
  },
  state: {
    label: "Stato",
    placeholder: "Seleziona stato",
    errors: {
      required: "Lo stato è obbligatorio",
      invalid: "Seleziona uno stato valido",
    },
  },
  jurisdiction: {
    label: "Giurisdizione della licenza",
    placeholder: "Seleziona giurisdizione della licenza",
    errors: {
      required: "La giurisdizione della licenza è obbligatoria",
      invalid: "Seleziona una giurisdizione valida",
    },
  },
  zipCode: {
    label: "Codice postale",
    placeholder: "00100",
    errors: {
      required: "Il codice postale è obbligatorio",
      invalid: "Inserisci un codice postale valido",
    },
  },
  role: {
    label: "Ruolo",
    placeholder: "Seleziona il tuo ruolo",
    errors: {
      required: "Seleziona il tuo ruolo",
      invalid: "Seleziona un ruolo valido",
    },
  },
  businessType: {
    label: "Tipo di azienda",
    placeholder: "Seleziona tipo di azienda",
    errors: {
      required: "Il tipo di azienda è obbligatorio",
      invalid: "Seleziona un tipo di azienda valido",
    },
  },
  businessName: {
    label: "Nome azienda",
    placeholder: "Inserisci il nome dell'azienda",
    errors: {
      required: "Il nome dell'azienda è obbligatorio",
      minLength: "Il nome dell'azienda deve contenere almeno 2 caratteri",
      maxLength: "Il nome dell'azienda può contenere massimo 100 caratteri",
    },
  },
  businessSearch: {
    label: "Ricerca azienda:",
    addNewAccount: "Aggiungi nuovo account aziendale",
    canNotFindBusiness: "Non trovi la tua azienda?",
    guideline:
      "Inserisci il tuo codice postale, quindi seleziona dall'elenco qui sotto.",
    guidelineForNameSearch:
      "Inserisci il nome completo dell'azienda, quindi seleziona dall'elenco.",
    placeholder: "Dove lavori?",
    noResults: "Nessun risultato trovato",
    searching: "Ricerca in corso...",
    selectedBusinessHeading: "Azienda selezionata:",
    selectedBusinessNotCorrect: "Non è corretto?",
    selectedBusinessTryAgain: "Riprova",
    selectedBusinessDismiss: "Ignora azienda",
    resultsFound: {
      singular: "1 azienda trovata",
      plural: "Più aziende trovate",
    },
    errors: {
      network:
        "Si stanno verificando problemi nella connessione al servizio di ricerca aziende. Si prega di riprovare più tardi.",
    },
  },
  explicitConsent: {
    label:
      "Spuntando questa casella accetto i Termini d'uso di Elanco e confermo che Elanco raccoglierà ed elaborerà i miei dati personali in conformità con l'Informativa sulla privacy di Elanco",
    errors: {
      required: "Il consenso email è obbligatorio",
    },
  },
  explicitSmsConsent: {
    label:
      "Selezionando questa casella accetto di ricevere comunicazioni di marketing da Elanco tramite SMS/messaggio di testo.",
    errors: {
      required: "Il consenso agli SMS è obbligatorio",
    },
  },
  telephone: {
    label: "Telefono personale",
    placeholder: "Inserisci il tuo numero di telefono personale",
    dialCodeLabel: "Codice",
    dialCodePlaceholder: "Cerca paese…",
    errors: {
      invalid: "Inserisci un numero di telefono valido.",
    },
  },
  businessTelephone: {
    label: "Telefono aziendale",
    placeholder: "Inserisci il numero di telefono aziendale",
    dialCodeLabel: "Codice",
    dialCodePlaceholder: "Cerca paese…",
    errors: {
      invalid: "Inserisci un numero di telefono valido.",
    },
  },
  professionalNumber: {
    label: "Numero professionale",
    placeholder: "1234567",
    errors: {
      required: "Inserisci un numero professionale",
      maxLength: "L'inserimento supera il limite di caratteri",
    },
  },
  addressSearch: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  businessSearchField: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  checkbox: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  combobox: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  datePicker: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  dateRange: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  dateTime: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  emailField: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  fileInput: {
    errors: {
      required: "Seleziona un file",
    },
  },
  number: {
    errors: {
      required: "Inserisci un numero",
      minValue: "Inserisci un valore superiore al minimo",
      maxValue: "Inserisci un valore inferiore al massimo",
    },
  },
  passwordField: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  rangeSlider: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  select: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  telephoneField: {
    errors: {
      required: "Inserisci solo numeri",
      invalidTelephone: "Inserisci un numero di telefono valido",
      invalidFormat: "Formato numero non valido",
    },
  },
  text: {
    errors: {
      required: "Utilizza solo lettere (A-Z), numeri (0-9) e nessun simbolo",
      maxLength: "L'inserimento supera il limite di caratteri",
      minLength: "L'inserimento deve contenere almeno 2 caratteri",
    },
  },
  textarea: {
    characters: "caratteri",
  },
  time: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  form: {
    errors: {
      generic: "Si è verificato un errore durante l'invio del modulo. Riprova.",
      reportAnIssue: "Segnala un problema.",
      configuration: "Errore di configurazione",
      noFormQuestionsAvailable: "Nessuna domanda del modulo disponibile.",
      formComponentLoad:
        "Il componente del modulo non può essere caricato a causa di un campo non supportato.",
      code: "Codice",
      type: "Tipo",
      missingRequiredFields:
        "Questo modulo manca dei campi obbligatori (Email e/o Consenso). Si prega di contattare un amministratore per correggere la configurazione del modulo.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Protezione Animali - Veterinario",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Produttore - Misto/Altro",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Rivenditore",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Allevatore di pecore",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinario",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Veterinario", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinario, Titolare della Clinica",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Assistente Veterinario",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Clinica Veterinaria - Altro",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Clinica Veterinaria - Veterinario",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Clinica Veterinaria - Infermiere Veterinario",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Specialista Veterinario",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinario",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Sig.",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Sig.",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Sig.ra",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Sig.ra",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professore",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
